import { render, staticRenderFns } from "./TaskDurationKpiChartSmall.vue?vue&type=template&id=f1ada1ba&"
import script from "./TaskDurationKpiChartSmall.vue?vue&type=script&lang=js&"
export * from "./TaskDurationKpiChartSmall.vue?vue&type=script&lang=js&"
import style0 from "./TaskDurationKpiChartSmall.vue?vue&type=style&index=0&id=f1ada1ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports